import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  LogoMinhaBunge,
  TextoRegras,
  ColunaRegras,
  TitRegrasPontuacao,
  ColunaRegulamento
} from './Estilos'

import BgRegras from "./Images/BgBunge.jpg";
import ImgLogoMinhaBunge from "./Images/LogoMinhaBunge.png"

function Privacidade(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);
  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");  
  const [TituloRegulamento, setTituloRegulamento] = useState("");
  const [TextoRegulamento, setTextoRegrasIndireto] = useState("");

  useEffect(() => {
        PegaTextoRegras();
  }, []);

  async function PegaTextoRegras() {
    
    var requestOptions = { method: 'GET', redirect: 'follow' };
    
    fetch(URLBunge + '/api/Regulamentos/ListaRegulamentosTipo/1', requestOptions)
      .then(response => response.json())
      .then(result => {
          console.log(result);
          setTituloRegulamento(result.regulamentos[0].descricao);
          setTextoRegrasIndireto(result.regulamentos[0].regulamento.replace(/(?:\r\n|\r|\n)/g, "<br>"));
          setLoading(false)
      })
      .catch(error => console.log('error', error));
    
  }

  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={BgRegras} BackgroundMob={BgRegras} bgcolor={'#3c647d'}>
            
            <ColunaRegulamento>
                <div className={'AreaColunaRegras'}>
                    <LogoMinhaBunge src={ImgLogoMinhaBunge} MaxWidth={'200px'} />
                    <Clear />
                    <TitRegrasPontuacao>{ReactHtmlParser(TituloRegulamento)}</TitRegrasPontuacao>                    
                    <TextoRegras>
                        <div className={'TextoRegras'}>{ReactHtmlParser(TextoRegulamento)}</div>
                    </TextoRegras>
                </div>  
            </ColunaRegulamento>
            
         </BackgroundImg>
    </>
  );

}

export default Privacidade;
